<!-- src/components/common/CustomMultiselect.vue -->
<template>
  <div>
    <h5 class="uk-text-bold mb-2">{{ title }} </h5>
    <multiselect
        v-model="selectedValue"
        :options="options"
        :multiple="isMultiple"
        :searchable="isSearchable"
        :close-on-select="closeOnSelect"
        :allow-empty="allowEmpty"
        :placeholder="placeHolderText"
        :selectLabel="computedSelectLabel"
        :selectedLabel="computedSelectedLabel"
        :deselectLabel="computedDeselectLabel"
        :tag-placeholder="$t('general.select')"
        :label="label"
        :track-by="trackBy"
        :disabled="isDisabled"
        @input="handleInput"
        @tag="handleTagRemove"
    >
      <template #option="{ option }">
        {{ option.name }}
      </template>

      <template #noResult>
        <div class="no-results">
          {{ $t('general.no_results_found') }}
        </div>
      </template>

      <template slot="noOptions">
        <span>{{ $t('general.no_options') }}</span>
      </template>

      <template #tag="{ option, remove }">
        <span class="multiselect__tag">
          <span>{{ option.name }}</span>
          <i 
            aria-hidden="true" 
            tabindex="1" 
            class="multiselect__tag-icon"
            @click.stop="handleTagClick(option, remove)"
          ></i>
        </span>
      </template>

    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'CustomMultiselect',

  components: {
    Multiselect
  },

  props: {
    value: {
      type: [Array, Object],
      default: () => []
    },
    options: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      default: 'name'
    },
    title: {
      type: String,
      default: ''
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    isSearchable: {
      type: Boolean,
      default: true
    },
    allowEmpty: {
      // input içi boş kalabilir mi : false=input içinde mutlak tek öğe kalacak son öğe silinemez
      type: Boolean,
      default: false
    },
    trackBy: {
      type: String,
      default: 'id'
    },
    closeOnSelect:{
      type: Boolean,
      default: false
    },
    placeholder:{
      type:String,
      default:''
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    selectLabel: {
      type: String,
      default: ''
    },
    selectedLabel: {
      type: String,
      default: ''
    },
    deselectLabel: {
      type: String,
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
  },

  computed: {
    placeHolderText() {
      return this.placeholder || this.$t('general.select');
    },
    selectedValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    computedSelectLabel() {
      return this.hideLabel ? '' : this.$t('general.select');
    },
    computedSelectedLabel() {
      return this.hideLabel ? '' : this.$t('general.selected');
    },
    computedDeselectLabel() {
      return this.hideLabel ? '' : this.$t('general.deselect');
    }
  },

  methods: {
    handleInput(value) {
    },
    handleTagRemove(searchQuery, id) {
    },
    handleTagClick(option, remove) {
      remove(option);

      this.$nextTick(() => {
        this.$emit('input', this.selectedValue);
      });
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css" />

